import {
  apiStatus,
  paymentInitActionType,
  lenderListActionType,
  paymentEnterMobileActionType,
  commonActionType,
  offlineActionType,
  PAYMENT_ERROR_DATA,
  paymentConfirmActionType,
} from '../../actionTypes';

import paymentEnterMobileAction from '../../actions/onPaymentEnterMobile/actionType';

export const initialState = {
  transactionInfoApiState: apiStatus.NONE,
  getKfsDataApiState: apiStatus.NONE,
  posTransactionDetailsApiState: apiStatus.NONE,
  lenderDetailsStatus: apiStatus.NONE,
  transactionInfoPreSelectedApiState: apiStatus.NONE,
  remainingTimeSeconds: '',
  merchantId: '',
  purchaseValue: '',
  mobile: '',
  userStatus: '',
  lenderDetailsList: [],
  payLaterLenderDetailsList: [],
  selectedLenderType: '',
  eligible: false,
  mobileNoError: '',
  errorMessage: '',
  isFlipkartOfferEligible: false,
  channel: '',
  posTxnStatus: '',
  posSmsAttempts: '',
  posSmsMessage: '',
  merchantName: '',
  detailsTimestampSeconds: '',
  showPaymentContainer: true,
  txnTerminated: false,
  kfsData: {},
  kfsEnabled: false,
  txnDetails: {},
  returnUrl: '',
  merchantLogoUrl: '',
  skipNtbPreEligibility: false,
};

const paymentDetails = (state = initialState, action) => {
  switch (action.type) {
    case paymentInitActionType.TRANSACTION_INFO_REQUEST:
      return {
        ...state,
        transactionInfoApiState: apiStatus.INITIATED,
        lenderDetailsStatus: apiStatus.INITIATED,
        errorMessage: '',
      };
    case paymentInitActionType.TRANSACTION_INFO_SUCCESS: {
      const {
        merchantId,
        purchaseValue,
        mobile,
        userStatus,
        lenderDetailsList,
        payLaterLenderDetailsList,
        selectedLenderType,
        remainingTimeSeconds,
        eligible,
        isFlipkartOfferEligible,
        channel,
        isNoCostEmiAvailable,
        detailsTimestampSeconds,
        merchantName,
        merchantLogoUrl,
        skipNtbPreEligibility,
      } = action.payload || {};
      return {
        ...state,
        transactionInfoApiState: apiStatus.SUCCESS,
        lenderDetailsStatus:
          (lenderDetailsList && lenderDetailsList.length) > 0 ||
          (payLaterLenderDetailsList && payLaterLenderDetailsList.length) > 0
            ? apiStatus.SUCCESS
            : apiStatus.NONE,
        merchantId,
        purchaseValue,
        mobile,
        mobileNoError: '',
        userStatus,
        lenderDetailsList,
        payLaterLenderDetailsList,
        selectedLenderType,
        eligible,
        errorMessage: '',
        remainingTimeSeconds,
        isFlipkartOfferEligible,
        channel,
        isNoCostEmiAvailable,
        detailsTimestampSeconds,
        merchantName,
        merchantLogoUrl,
        skipNtbPreEligibility,
      };
    }
    case paymentConfirmActionType.INITIATE_GET_KFS_DATA_REQUEST:
      return {
        ...state,
        getKfsDataApiState: apiStatus.INITIATED,
        errorMessage: '',
      };
    case paymentConfirmActionType.INITIATE_GET_KFS_DATA_SUCCESS:
      const { kfsEnabled, kfsData, txnDetails } = action.payload || {};
      return {
        ...state,
        getKfsDataApiState: apiStatus.SUCCESS,
        kfsData: kfsData,
        kfsEnabled: kfsEnabled,
        txnDetails: txnDetails,
      };
    case paymentConfirmActionType.INITIATE_GET_KFS_DATA_ERROR: {
      const { message } = action.payload;
      return {
        ...state,
        getKfsDataApiState: apiStatus.ERROR,
        errorMessage: message || state.errorMessage,
      };
    }
    case paymentInitActionType.UPDATE_TRANSACTION_LENDER_TYPE:
      const { selectedLenderType } = action.payload || {};
      return {
        ...state,
        selectedLenderType,
      };
    case paymentEnterMobileActionType.UPDATE_TRANSACTION_MOBILE_NUMBER: {
      const { mobile } = action.payload || {};
      return {
        ...state,
        mobile,
      };
    }
    case paymentEnterMobileActionType.UPDATE_TRANSACTION_MOBILE_NUMBER_ERROR:
      const { mobileNoError } = action.payload || {};
      return {
        ...state,
        errorMessage: mobileNoError,
        userTransactionInfoApiState: apiStatus.ERROR,
      };
    case paymentInitActionType.TRANSACTION_INFO_PRE_SELECTED_SUCCESS: {
      const { merchantId, purchaseValue, mobile, merchantName, returnUrl } =
        action.payload || {};
      return {
        ...state,
        transactionInfoPreSelectedApiState: apiStatus.SUCCESS,
        merchantId,
        purchaseValue,
        mobile,
        errorMessage: '',
        merchantName,
      };
    }
    case paymentInitActionType.TRANSACTION_INFO_ERROR: {
      const { errorMessage, channel } = action.payload;
      return {
        ...state,
        transactionInfoApiState: apiStatus.ERROR,
        lenderDetailsStatus: apiStatus.ERROR,
        errorMessage: errorMessage || state.errorMessage,
        channel: channel || state.channel,
      };
    }
    case lenderListActionType.USER_TRANSACTION_INFO_REQUEST:
      return {
        ...state,
        userTransactionInfoApiState: apiStatus.INITIATED,
        mobileNoError: '',
        errorMessage: '',
      };
    case lenderListActionType.USER_TRANSACTION_INFO_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...state,
        errorMessage,
        userTransactionInfoApiState: apiStatus.ERROR,
        transactionInfoApiState: apiStatus.ERROR,
      };
    }
    case paymentEnterMobileAction.mobileInvalid: {
      const { mobileNoError } = action.payload;
      return {
        ...state,
        mobileNoError,
      };
    }
    case offlineActionType.POS_TXN_STATUS_SUCCESS: {
      const { posTxnStatus } = action.payload;
      return {
        ...state,
        posTxnStatus,
      };
    }
    case offlineActionType.POS_TXN_DETAILS_REQUEST: {
      return {
        ...state,
        posTransactionDetailsApiState: apiStatus.INITIATED,
        lenderDetailsStatus: apiStatus.INITIATED,
        errorMessage: '',
      };
    }
    case offlineActionType.POS_SEND_SMS_TO_INITIATE_TXN_AUTH_REQUEST_SUCCESS: {
      const { posSmsAttempts, posSmsMessage } = action.payload;
      return {
        ...state,
        posSmsAttempts,
        posSmsMessage,
      };
    }
    case PAYMENT_ERROR_DATA:
    case paymentInitActionType.TRANSACTION_TIMEOUT_STORE: {
      const { channel } = action.payload || {};
      return {
        ...state,
        channel: channel || state.channel,
      };
    }
    case paymentInitActionType.UPDATE_TXN_TERMINATION_DATA: {
      const { displayPaymentContainer, txnTerminated } = action.payload || {};
      return {
        ...state,
        showPaymentContainer: displayPaymentContainer,
        txnTerminated: txnTerminated,
      };
    }
    case commonActionType.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
};

export default paymentDetails;



// WEBPACK FOOTER //
// ./components/transaction/src/reducer/paymentDetails/index.js